// Module
var code = "<g fill-rule=\"evenodd\"> <polygon points=\"45.6 59.835 54.4 59.835 54.4 23.6 45.6 23.6\"></polygon> <polygon points=\"45.6 76.4 54.4 76.4 54.4 67.6 45.6 67.6\"></polygon> </g> ";
// Exports
export default code;